import { analyzePromptStructure, PromptRules } from './promptFilter'
import { buildApiUrl } from '../config/api'

export interface PromptAnalysis {
  score: number
  suggestions: string[]
  analogy: string
  explanation: string
  ruleAnalysis: PromptRules
}

export async function analyzePrompt(prompt: string): Promise<PromptAnalysis> {
  // First, run rule-based analysis
  const ruleAnalysis = analyzePromptStructure(prompt)

  // If the prompt is empty or very poor, return rule-based analysis only
  if (ruleAnalysis.isEmpty || ruleAnalysis.score < 3) {
    return {
      score: ruleAnalysis.score,
      suggestions: ruleAnalysis.suggestions,
      analogy: ruleAnalysis.analogy,
      explanation: ruleAnalysis.isEmpty
        ? 'Введите ваш вопрос, чтобы получить помощь'
        : 'Запрос слишком короткий для полноценного анализа',
      ruleAnalysis
    }
  }

  try {
    // For better prompts, try to get LLM enhancement
    const response = await fetch(buildApiUrl('/api/analyze-prompt'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ prompt, ruleAnalysis })
    })

    if (!response.ok) {
      throw new Error(`Failed to analyze prompt: ${response.status}`)
    }

    const apiResponse = await response.json() as {
      score: number
      suggestions: string[]
      analogy: string
      explanation: string
    }
    return {
      score: apiResponse.score,
      suggestions: apiResponse.suggestions,
      analogy: apiResponse.analogy,
      explanation: apiResponse.explanation,
      ruleAnalysis
    }
  } catch (error) {
    // Fallback to enhanced rule-based analysis
    return {
      score: ruleAnalysis.score,
      suggestions: ruleAnalysis.suggestions,
      analogy: ruleAnalysis.analogy,
      explanation: generateExplanation(ruleAnalysis),
      ruleAnalysis
    }
  }
}

function generateExplanation(rules: PromptRules): string {
  if (rules.score >= 8) {
    return 'Отличный запрос! Он содержит достаточно контекста и конкретики.'
  } else if (rules.score >= 6) {
    return 'Хороший запрос, но можно улучшить добавив больше деталей.'
  } else if (rules.score >= 4) {
    return 'Запрос понятен, но нуждается в доработке для лучшего результата.'
  } else {
    return 'Запрос нуждается в значительном улучшении.'
  }
}